import D2C_ProviderStorage from './Storage'

class D2C_ProviderDropbox extends D2C_ProviderStorage {
  static objectType = 'providerType'
  static active = true
  static order = 31
  static providerType = 'Dropbox'
  static providerTitle = 'Dropbox'
  static oauth = true
  static fields = {
    ...D2C_ProviderStorage.fields,
    apiToken: {
      default: '',
      hidden: true,
      label: 'Token',
      path: 'auth.apiToken',
      required: true,
      validate(value) {
        return !value && this.required ? 'Must be filled' : null
      },
      creating: {},
    },
    refreshToken: {
      default: '',
      hidden: true,
      path: 'auth.refreshToken',
      required: false,
      validate(value) {
        return !value && this.required ? 'Must be filled' : null
      },
      creating: {},
    },
  }
}

export default D2C_ProviderDropbox
